import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import styled from "styled-components";

const DataGridUI = styled(DataGridPro)<DataGridProProps>(
  ({ theme, onRowClick }) => ({
    "& .super-app-theme--New": {
      backgroundColor: "#E8E8E8",
      "&:hover": {
        backgroundColor: "#F5F5F5!important",
      },
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#0f284c",
      color: "#fff",
    },
    "& .MuiDataGrid-columnHeader .MuiCheckbox-root svg": {
      color: "white",
    },
    "& .MuiDataGrid-menuIconButton": {
      color: "white", // Change the icon color to white
    },
    "& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon": {
      color: "white",
    },

    "& .MuiDataGrid-pinnedColumns--left .MuiDataGrid-columnHeaders": {
      backgroundColor: "lightblue", // Pinned headers ka background
      color: "black", // Text color
    },

    // Remove ALL focus borders and outlines from the entire DataGrid
    "&:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "&:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "&:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from the root grid element
    "& .MuiDataGrid-root": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-root:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from the main grid container
    "& .MuiDataGrid-main": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-main:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-main:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from individual cells
    "& .MuiDataGrid-cell": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-cell:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-cell:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from column headers
    "& .MuiDataGrid-columnHeader": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-columnHeader:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from rows
    "& .MuiDataGrid-row": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-row:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from virtual scroller
    "& .MuiDataGrid-virtualScroller": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-virtualScroller:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-virtualScroller:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    
    // Remove focus from any other grid elements
    "& *:focus": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& *:focus-visible": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
    "& *:focus-within": {
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
    },
  })
);

export default DataGridUI;
